import React from 'react';
import { Route } from 'react-router-dom';
import Login from '../../Login/Login.js';
import CreateUserPage from '../../DetailsUplode/CreateUserPage.js';
import CreateAdminPage from '../../DetailsUplode/CreateAdminPage.js';
import CacheSettings from '../../ListPages/Cachesettings.js';
import { ProtectedRoute } from '../ProtectedRoute.js';

export const loginAndAccessRoutes = [
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="create-user" path="/create-user" element={<CreateUserPage />} />,
  <Route
    key="create-admin"
    path="/create-admin"
    element={
      <ProtectedRoute allowedRoles={['Hr', 'ProjectManager']} element={<CreateAdminPage />} />
    }
  />,
  <Route key="cache-settings" path="/CacheSettings" element={<CacheSettings />} />,
];
